<template>
  <v-app id="vuetify-app" class="home-page-wrapper">
    <extend-test-subscription-component :is_able_to_extend_test_subscription="is_able_to_extend_test_subscription"/>
    <start-discount-modal-component :show_start_discount="show_start_discount_url" :start_discount_url="start_discount_url"/>
    <v-container fluid grid-list-md text-xs-center>
      <v-layout row v-if="!!update_info">
        <v-flex>
          <v-alert
              :value="true"
              type="warning"
          >
            <div v-html="getUpdateInfo()"></div>
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout row alignt-start wrap>
        <buttons-and-subscription-card-component
            :current_subscription_type_name="current_subscription_type_name"
            :last_subscription_end_date="last_subscription_end_date"
            :account_expires_in="account_expires_in"
            :buy_subscription_url="buy_subscription_url"
            :start_discount_url="start_discount_url"
            :show_start_discount_url="show_start_discount_url"
            :create_patient_link="create_patient_link"
            :create_product_link="create_product_link"
            :create_food_link="create_food_link"
            :create_schema_link="create_schema_link"
            :calendar_events="calendar_events"
        />

        <video-and-promotion-component :promotion="promotion"/>

        <latest-list-component
            :latest_food="latest_food"
            :latest_patients="latest_patients"
        />
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import {trans} from "../../app";

export default {
  props: {
    current_subscription_type_name: {
      type: String,
    },
    last_subscription_end_date: {
      type: String
    },
    account_expires_in: {
      type: String
    },
    buy_subscription_url: {
      type: String
    },
    start_discount_url: {
      type: String
    },
    show_start_discount_url: {
      type: Boolean
    },
    update_info: {
      type: String
    },
    create_patient_link: {
      type: String
    },
    create_product_link: {
      type: String
    },
    create_food_link: {
      type: String
    },
    create_schema_link: {
      type: String
    },
    latest_food: {
      type: String
    },
    latest_patients: {
      type: String
    },
    promotion: {
      type: String,
      required: false
    },
    is_able_to_extend_test_subscription: {
      type: Boolean
    },
    calendar_events: {
        type: Array,
    },
  },
  methods: {
    getUpdateInfo() {
      return trans('app.pages.home.new_version', {"release_date": this.update_info});
    }
  }
}
</script>

<style scoped>
.home-page-wrapper {
  background: none;
}
.container{
  padding:0;
}
</style>
